<template>
  <div class="found">
    <div class="found-message">
      {{ $l.cardNotFound }}
    </div>
    <button-full-screen :action="hide" />
  </div>
</template>

<script>
import ButtonFullScreen from '@/components/ButtonFullScreen'
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],
  components: {
    ButtonFullScreen
  },

  methods: {
    hide: function () {
      this.$store.dispatch('popupQuiz/hide', null)
    }
  }
}
</script>

<style lang="scss" scoped>
.found {
  &-message {
    text-align: center;
    color: white;
    font-size: 1.6em;
    font-weight: bold;
  }
}
</style>
